import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: {
    emailChange: {
      open: false,
    },
    passwordChange: {
      open: false,
    },
  },
};

const myAccountControlSlice = createSlice({
  name: "myAccountControl",
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      const { modalType } = action.payload;
      state.modals[modalType] = { open: true };
    },
    closeModal: (state, action) => {
      const { modalType } = action.payload;
      state.modals[modalType] = { open: false };
    },
  },
});

export const { openModal, closeModal } = myAccountControlSlice.actions;
export default myAccountControlSlice.reducer;
